import { adminRoute } from "Pages/admin/Routes";
import { getAIAgentsRoute } from "Pages/agentBuilder/Pages/Routes";
import { agentDesktopRoute } from "Pages/agentDesktop/Routes";
import { audienceRoute } from "Pages/audience/audienceRoutes";
import { rerouteSegmentRoute } from "Pages/audience/Pages/SegmentsPage/Pages/segmentRoutes";
import { getConvoIntelRoute } from "Pages/convoIntel/ConvoIntelRoutes";
import { rerouteTranscriptsRoute } from "Pages/convoIntel/TranscriptRoutes";
import { copilotRoute } from "Pages/copilot/copilotRoutes";
import {
    getLiveOpsRoute,
    rerouteAgentsRoute,
    rerouteTasksRoute,
    rerouteRecentTasksRoute,
    rerouteRecentActivityRoute,
    rerouteQueuesRoute,
} from "Pages/liveOps/liveOpsRoutes";
import { getOrchestrationRoute } from "Pages/orchestration/orchestrationRoutes";
import { rerouteCampaignsRoute } from "Pages/orchestration/Pages/campaigns/Pages/CampaignsRoutes";
import { rerouteJourneysRoute } from "Pages/orchestration/Pages/journeys/Routes";
import { regalLiveAiRoute, regalLiveRoute } from "Pages/regal-live/regalLiveRoutes";
import { reportingRoute } from "Pages/reporting/reportingRoutes";
import { settingsRoute } from "Pages/settings/Routes";
import { lazyWithRetries } from "Utils/LazyWithRetries/LazyWithRetries";

import { AppPagePaths } from "./paths";

import type { RegalRouteObject } from "./types";
import type { AIAgentsFlags } from "Pages/agentBuilder/Pages/Routes";
import type { ConvoIntelFlags } from "Pages/convoIntel/ConvoIntelRoutes";
import type { LiveOpsFlags } from "Pages/liveOps/liveOpsRoutes";
import type { OrchestrationFlags } from "Pages/orchestration/orchestrationRoutes";

const JourneysActiveUsersPage = lazyWithRetries(
    "Journey active user page",
    () => import("Pages/orchestration/Pages/journeys/ActiveUsers")
);

type GetAllRoutesParams = {
    convoIntelPages: ConvoIntelFlags;
    liveOpsPages: LiveOpsFlags;
    orchestrationPages: OrchestrationFlags;
    aiAgentsPages: AIAgentsFlags;
};

export const getAllRoutes = ({
    convoIntelPages,
    liveOpsPages,
    orchestrationPages,
    aiAgentsPages,
}: GetAllRoutesParams): RegalRouteObject[] => {
    // Base routes that are always included
    const baseRoutes: RegalRouteObject[] = [
        adminRoute,
        agentDesktopRoute,
        getAIAgentsRoute(aiAgentsPages),
        reportingRoute,
        {
            path: `${AppPagePaths.journeysUsers}/:journeyId/:nodeId`,
            element: <JourneysActiveUsersPage />,
        },
        {
            path: `${AppPagePaths.journeysUsers}/:journeyId`,
            element: <JourneysActiveUsersPage />,
        },
        regalLiveRoute,
        regalLiveAiRoute,
    ];

    return [
        ...baseRoutes,
        settingsRoute,
        getOrchestrationRoute(orchestrationPages),
        getLiveOpsRoute(liveOpsPages),
        audienceRoute,
        getConvoIntelRoute(convoIntelPages),
        copilotRoute,
        // rerouting backwards compatibility for legacy nav
        rerouteCampaignsRoute,
        rerouteJourneysRoute,
        rerouteSegmentRoute,
        rerouteAgentsRoute,
        rerouteTasksRoute,
        rerouteRecentTasksRoute,
        rerouteRecentActivityRoute,
        rerouteQueuesRoute,
        rerouteTranscriptsRoute,
    ];
};
